module.exports = __webpack_public_path__ + "03_short_black.bdbcea1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_short_black.png
// module id = sIui
// module chunks = 0